import React from 'react';

import { ScrollView } from '@rbilabs/universal-components';
import { usePaymentContext } from 'features/payment';

import { ActionsheetContent, ActionsheetWrapper } from 'components/action-sheet';
import noop from 'utils/noop';

import { PaymentMethodSelectorHeader } from './payment-method-selector-header';
import { PaymentMethodSelectorOptions } from './payment-method-selector-options';
import { ContentWrapper } from './styled';
import { IPaymentMethodSelectorProps } from './types';

export const PaymentMethodSelectorBottomSheet = ({
  isOpen = false,
  onClose,
  onConfirm,
  methods,
  selectedMethodId,
  isReloadDrawer,
  reloadSelectedMethodId = '',
  setIsGiftCardVisible = noop,
}: IPaymentMethodSelectorProps) => {
  const { noPaymentMethodsAvailable } = usePaymentContext();

  return (
    <ActionsheetWrapper
      isOpen={isOpen}
      onOpenEventMessage="Payment Method Drawer"
      onClose={onClose}
      width="full"
      alignSelf="auto"
    >
      <ActionsheetContent>
        <ScrollView showsVerticalScrollIndicator width="full">
          <ContentWrapper>
            <PaymentMethodSelectorHeader
              isReloadDrawer={isReloadDrawer}
              noPaymentMethodsAvailable={noPaymentMethodsAvailable}
              onClose={onClose}
            />

            <PaymentMethodSelectorOptions
              {...{
                onConfirm,
                onClose,
                methods,
                selectedMethodId,
                isReloadDrawer,
                setIsGiftCardVisible,
                reloadSelectedMethodId,
              }}
            />
          </ContentWrapper>
        </ScrollView>
      </ActionsheetContent>
    </ActionsheetWrapper>
  );
};
